<div class="container-fluid datamonitor-select">
  <div class="row contents-div">
    <div class="left-div"></div>
    <div class="middle-div px-0"></div>
    <!-- 項目リスト設定ボタン -->
    <div class="right-div">
      <b-button
        @click="showConfigExportModal"
        size="sm"
        id="button"
        variant="primary"
        style="margin-right: 10px; margin-top: 10px;"
        :disabled="!isAbleExportButton"
      >
        {{ $t('individual.button_data_monitor_item_list_export') }}
      </b-button>
      <b-button
        @click="showConfigImportModal"
        size="sm"
        id="button"
        variant="primary"
        style="margin-top: 10px;"
      >
        {{ $t('individual.button_data_monitor_item_list_import') }}
      </b-button>
    </div>
  </div>
  <div class="row contents-div">
    <div class="selected-count-label">{{ $t('message.label_selected_data_monitor_item_count', [selectedFunctionList?.length || 0]) }}</div>
    <!-- left list -->
    <div class="left-div">
      <b-form class="filter-form mt-4" autocomplete="off" @contextmenu.once="() => {showDebugButton ? showDebugButton() : logWrapper.log('not implement');}">
          <b-form-input v-model="filterText" :placeholder="$t('individual.label_data_monitor_filter')" type="text"
            id="filter-text" class="" size="sm" autocomplete="off" @input="updateFilter" />
          <b-form-select v-if="dataMonitorFunctionSettings.isSystemSelect"
            class="custom-select custom-select-sm" v-model="selectedSystem" size="sm" style="margin-left: 10px;"
            :options="translatedSystemName"
            @change="changeSystem"
          />
          <b-form-select
            class="custom-select custom-select-sm"
            v-model="selectedSignalGroup"
            @change="updateFilter"
            size="sm"
            :options="filteredSignalGroupList.length ? filteredSignalGroupList : signalGroupList"
            style="margin-left: 10px;"
          >
            <template #first>
              <b-form-select-option :value="null" disabled>{{ $t('individual.placeholder_select_signal_group') }}</b-form-select-option>
            </template>
          </b-form-select>
        </b-form>
      <b-button v-if="showDebug" @click="downloadTSV" style="width: 70px !important; height: 20px !important; font-size: 9px !important;">Download</b-button><!-- for debug -->

      <cstm-table
        useStripeStyle
        rowSelect
        usePopup
        useSort
        hasTabs
        class="support-table mt-2"
        type="simple"
        ref="filtered_tbl"
        :currentSortkey="currentSortkey"
        :items="escapeFunctionList(filterFunctionList)"
        :columns="systemTableColumns"
        @rowClicked="clickRow"
      >
      </cstm-table>
    </div>

    <!-- middle btns -->
    <div class="middle-div px-0">
      <div class="button-container text-center short-buttons">
        <b-button
          @click="handleAllAppendButtonClick"
          size="sm"
          class="btn-short"
          variant="primary"
          >{{ $t('individual.button_data_monitor_all_add') }}</b-button
        ><br />
        <b-button
          @click="handleAppendButtonClick"
          size="sm"
          class="mt-2 btn-short"
          variant="primary"
          >{{ $t('individual.button_data_monitor_add') }}</b-button
        ><br />
        <b-button
          @click="handleRemoveButtonClick"
          size="sm"
          class="mt-2 btn-short"
          variant="primary"
          >{{ $t('individual.button_data_monitor_delete') }}</b-button
        ><br />
        <b-button
          @click="handleAllRemoveButtonClick"
          size="sm"
          class="mt-2 btn-short"
          variant="primary"
          >{{ $t('individual.button_data_monitor_all_delete') }}</b-button
        >
      </div>
    </div>
    <!-- right list -->
    <div class="right-div">
      <b-form class="filter-form mt-4" autocomplete="off">
        <b-form-input v-model="filterTextRemove" :placeholder="$t('individual.label_data_monitor_filter')" type="text"
          id="filter-text-remove" class="" size="sm" autocomplete="off" @input="updateFilterRemove" />
      </b-form>
      <cstm-table
        useStripeStyle
        rowSelect
        hasTabs
        usePopup
        initSortDir="asc"
        id="selected"
        class="support-table mt-2"
        type="simple"
        ref="selected_tbl"
        :items="escapeFunctionList(filterRemoveFunctionList)"
        :columns="cstmTableColumns"
        :useSort="dataMonitorFunctionSettings.isSystemSelect"
        :currentSortkey="dataMonitorFunctionSettings.isSystemSelect ? selectedTableSort.currentSortKey : ''"
        @rowClicked="clickRowRemove"
      >
      </cstm-table>
      <div class="text-right w-100">
        <b-button
          @click="startExecute"
          size="sm"
          class="mt-2"
          variant="primary"
        >
          {{ $t('individual.button_data_monitor_start') }}
        </b-button>
      </div>
    </div>
  </div>

  <!-- 項目リスト用のモーダル定義 -->
  <b-modal v-model="showCstmListModal" size="lg" :header-bg-variant="headerColor" header-text-variant="light"
    no-close-on-backdrop no-close-on-esc centered no-stacking>
    <template v-slot:header>
      <div class="text-center w-100">
        {{ headerTitle }}
      </div>
    </template>  
    <template v-slot:default>
      <b-overlay opacity="0.3" spinner-variant="primary">
        <div class="container-fluid" style="min-height: 140px;">
          <div class="w-100">
            <div class="box-margin-right" style="white-space: break-spaces;" v-html="modalMessage">
            </div>
          </div>
          <div v-if="showInputArea" class="mx-auto file-selector">
            <form ref="form">
              <input style="display: none" ref="input" type="file" accept="application/json" @change="selectFile"
                v-bind="importFile">
            </form>
            <b-input-group>
              <b-input-group-prepend>
                <b-button variant="primary" @click="openFolder()" style="height: auto;">
                  {{ $t('individual.label_data_monitor_item_list_import_form_browse') }}
                </b-button>
              </b-input-group-prepend>
              <b-form-input type="text" class="form-control" :value="fileName" disabled
                :placeholder="setPlaceHolderMessage()">
              </b-form-input>
            </b-input-group>
          </div>
        </div>
      </b-overlay>
    </template>
    <template v-slot:footer>
      <div class="w-100 text-center ">
        <b-button v-if="showButtonCancel" size="sm" variant="outline-primary" @click="onCancelClicked" class="mx-2">
          {{ $t('message.common_button_cancel') }}
        </b-button>
        <b-button v-if="showButtonOk" size="sm" variant="primary" @click="onOkClicked" class="mx-2" :disabled="!isAbleOkButton">
          {{ $t('message.common_button_ok') }}
        </b-button>
      </div>
    </template>
  </b-modal>
  
  <processing-view :processing="processing"></processing-view>
</div>
